import react from "react";
import Request from "../../../../api/Requests";

const getPromotersList = (params) => {
    
    return Request('guestlist-promoters/list-promoters', 'GET', params, true);
}

const getPromotersStats = (params) => {
    return Request('guestlist-promoters/list-promoters-stats', 'GET', params, true);
}

const deletePromoter = (params) => {
    
    return Request('guestlist-promoters/delete-promoter', 'POST', params, true);
}

export default {
    getPromotersList,
    deletePromoter,
    getPromotersStats
}